import { useQuery } from '@tanstack/react-query';
import { enterpriseApiClient } from '../../client';
import { WorkOrdersApi } from '../../openapi';
import type { WorkOrderDocumentViewModel } from '../../openapi';
import useOnlineStatus from '@hooks/useOnlineStatus';

export const useWorkOrderDocuments = (jobNumber: string, enabled = true) => {
  const isOnline = useOnlineStatus();
  const workOrdersApi = new WorkOrdersApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  return useQuery<WorkOrderDocumentViewModel[], Error>({
    queryKey: ['workorders', 'documents', jobNumber],
    queryFn: async () => {
      const response = await workOrdersApi.apiWorkOrdersJobNumberDocumentsGet({
        jobNumber
      });
      return response.data;
    },
    enabled: enabled && !!jobNumber && isOnline,
    refetchOnMount: isOnline,
    refetchOnWindowFocus: isOnline,
    staleTime: 0,
    gcTime: 5 * 60 * 1000
  });
};
